/** Who sees „Platby“ in the menu (frontend §11.2, C2). */
import { Permission } from '@insio/shared-types';

/**
 * Any of these opens the payables and the runs; the queries refuse everyone else.
 * `PAYMENTS_RECORD` alone acts on the invoice and needs no menu.
 */
export const PAYMENTS_MENU_PERMISSIONS: readonly Permission[] = [
  Permission.PAYMENTS_PREPARE,
  Permission.PAYMENTS_APPROVE,
  Permission.PAYMENTS_RELEASE,
  Permission.PAYMENTS_RECONCILE
];

/** Whether the viewer sees the payments section. */
export function canOpenPayments(hasPermission: (permission: Permission) => boolean): boolean {
  return PAYMENTS_MENU_PERMISSIONS.some(permission => hasPermission(permission));
}
